/**
 * Host surface binding for the debug "macro running" indicator.
 *
 * Shows the blue flashing dot in the upper-left corner while a macro is
 * running, but only in debug (development) builds. Macro-running state comes
 * from `macroRunningState`, which is mirrored from StatefulMacroCoordinator in
 * coordinators/init.ts.
 */

import constants from '@playcastdotio/GlobalConfig';
import { MacroRunningIndicator } from '@playcastdotio/SharedComponents';
import { macroRunningState } from '../api/stores/shared';
import { useStoreListener } from '../useStoreListener';

const isDebugMode = (): boolean => constants.ENVIRONMENT === 'development';

export const HostMacroRunningIndicator = () => {
  const { macroRunning } = useStoreListener<{ macroRunning: boolean }>(macroRunningState);
  return <MacroRunningIndicator visible={isDebugMode() && macroRunning} />;
};
